<template>
  <div>
    <app-property
      v-for="field in datasource.fields"
      :key="`datasource-item-${field.id}`"
      :property="field"
      :propertyData="currentItem.data[field.id] || null"
      @change="onPropertyChange(field.id, $event)"
    ></app-property>
    <div class="_d-flex _content-end-h">
      <a-button type="primary" @click="saveItem">Save</a-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "edit-item",
  props: {
    datasource: {
      type: Object
    },
    item: {
      type: Object
    }
  },
  data() {
    return {
      currentItem: this.item
    };
  },
  methods: {
    saveItem() {
      this.currentItem.datasourceId = this.datasource.id;

      const isUpdate = !!this.currentItem.id;
      const method = isUpdate ? "put" : "post";

      this.axios[method](
        `/admin/datasource/${this.datasource.id}/item${
          isUpdate ? "/" + this.currentItem.id : ""
        }`,
        {
          datasourceItem: this.currentItem
        }
      ).then(() => {
        this.$message({
          message: "Item has been saved.",
          type: "success"
        });
      });

      this.$emit("afterSave", this.currentItem);
    },
    onPropertyChange(id, data) {
      this.$set(this.currentItem.data, id, data);
      // this.currentItem.data[id] = data;
    }
  },
  components: {}
};
</script>
